<script lang="ts" setup>
import { getCurrentInstance } from "vue";
import BaseInput from "./_base.vue";
import { useField } from "vee-validate";

interface Props {
    name: string;
    label: string;
    value?: string;
    onValue: string;
}

const props = withDefaults(defineProps<Props>(), {
    name: undefined,
    label: undefined,
    value: undefined,
    onValue: "aan",
});

const { value: initialValue, errorMessage, handleBlur, handleChange, meta, checked } = useField(props.name, undefined, { type: "radio" });

const uid = getCurrentInstance()?.uid;

const handleChangeEvent = (e: any) => {
    if (e.target.value === "on") {
        handleChange(props.onValue);
    }
};
</script>

<template>
    <BaseInput :errorMessage="errorMessage" :meta="meta" :name="name">
        <div class="relative flex items-start">
            <div class="flex h-5 items-center">
                <input :id="`${name}_${uid}_id`" :aria-describedby="`${name}-description`" :checked="initialValue === onValue" @input="handleChangeEvent" :name="name" type="radio" class="h-5 w-5 border-gray-500 accent-orange" />
            </div>
            <div class="ml-2">
                <label :for="`${name}_${uid}_id`" class="text-black">{{ label }}</label>
            </div>
        </div>
    </BaseInput>
</template>
